const USER_DEFINED_DEFAULT_SEARCH_NAME = 'User Defined Default Search';

export { USER_DEFINED_DEFAULT_SEARCH_NAME };
